// extracted by mini-css-extract-plugin
export default {"container":"ltck","header":"vjc_","divider":"bcv5","serviceSections":"gKow"};